import { Component, Input, forwardRef, OnInit } from '@angular/core';

import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { LinkFieldModel } from '../../../models/link-field.model';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { LinkDialogComponent } from '../../../../../Common/Dialogs/components/LinkDialog/link-dialog.component';
import { LinkModel } from '../../../../../Common/Forms/models/link.model';
import { DropdownOptionModel } from '../../../../../Common/Forms/models/dropdown-option.model';
import { LinkTypeEnum } from '../../../../../Common/Forms/enums/link-type.enum';

@Component({
    selector: 'agpr-link-field',
    templateUrl: './link-field.component.html',
    styleUrls: ['./link-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => LinkFieldComponent)
        }
    ],
    standalone: false
})
export class LinkFieldComponent extends AbstractFormFieldComponent implements OnInit {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() declare field: LinkFieldModel;
    @Input() declare value: LinkModel;

    displayLink: string;

    constructor(
        private coreDialogService: CoreDialogService
    ) {
        super();
    }

    ngOnInit() {
        if (!this.value) {
            return;
        }
        if (this.value.type === LinkTypeEnum.URL) {
            this.displayLink = this.value.url;
        } else {
            this.displayLink = this.value.email;
        }
    }

    openLinkDialog() {
        this.coreDialogService.open(LinkDialogComponent, {
            inputs: {
                heading: 'Common.dialog.linkType.insertLink',
                link: this.value,
                availableLinkTypes: [
                    new DropdownOptionModel('Common.dialog.linkType.webAddress', LinkTypeEnum.URL),
                    new DropdownOptionModel( 'Common.dialog.linkType.emailAddress', LinkTypeEnum.EMAIL)
                ],
                isLinkField: true
            },
            outputs: {
                dialogClose: (link: LinkModel) => {
                    if (link) {
                        this.value = link;
                        if (this.value.type === LinkTypeEnum.URL) {
                            this.displayLink = this.value.url;
                        } else {
                            this.displayLink = this.value.email;
                        }
                        this.changes.emit(this.value);
                    }
                },
                removeLink: () => {
                    this.value = null;
                    this.displayLink = null;
                    this.changes.emit(this.value);
                }
            }
        });
    }
}
